<template>
  <div class="x-header">
    <div class="x-header__wrapper flex align-center justify-between">
      <div class="x-header__left flex align-center justify-between flex-sub">
        <p class="tab-item logo" @click="navigatorTo('/')">
          <img :src="logo" alt />
        </p>
        <!-- <p
          class="tab-item"
          :class="{
            'header-current': $route.path.indexOf('/packageshop/') >= 0,
          }"
          @click="navigatorTo('/packageshop/setmeal/list')"
        >
          套餐商城
        </p> -->
        <div class="tab-item">
          <el-popover
            trigger="hover"
            popper-class="cu-el-popover"
            v-if="visable"
          >
            <div class="child-tab">
              <div
                class="child-tab__item"
                :class="{
                  active: isActive('/product/single'),
                }"
                @click="navigatorTo('/product/single')"
              >
                找单品
              </div>
              <div
                class="child-tab__item"
                :class="{
                  active: isActive('/shopcar' || '/sub' || '/shopintention'),
                }"
                @click="navigatorTo('/shopcar')"
              >
                购物车
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/order/list' || '/order/detail') }"
                @click="navigatorTo('/order/list')"
              >
                订单
              </div>
              <div
                class="child-tab__item"
                :class="{
                  active: isActive('/project/list?channel=xshop'),
                }"
                @click="navigatorTo('/project/list?channel=xshop')"
              >
                软装报价单
              </div>
            </div>
            <span slot="reference"
              >软装&定制<i class="el-icon-arrow-down"></i
            ></span>
          </el-popover>
          <span v-else @click="$login()">软装&定制</span>
        </div>
        <div class="tab-item">
          <!-- <el-popover
            trigger="hover"
            popper-class="cu-el-popover"
            v-if="visable"
          >
            <div class="child-tab">
              <div
                class="child-tab__item"
                :class="{
                  active: isActive('/project/list?channel=xshop'),
                }"
                @click="navigatorTo('/project/list?channel=xshop')"
              >
                软装报价
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/xhshop/newproject', true) }"
                @click="navigatorTo('/xhshop/newproject')"
              >
                新项目选材
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/xhshop/newchange', true) }"
                @click="navigatorTo('/xhshop/newchange')"
              >
                项目变更
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/xhshop/project', true) }"
                @click="navigatorTo('/xhshop/project')"
              >
                精装&踏之报价
              </div>
            </div>

            <span slot="reference">选材<i class="el-icon-arrow-down"></i></span>
          </el-popover> -->
          <span @click="navigatorTo('/xhshop/project')">选材&三方补充</span>
        </div>
      </div>

      <!-- <div class="input-search">
        <i class="el-icon-search icon-input icon_sousuo" v-on:click="doSearch"
          >&#xe65b;</i
        >
        <input
          type="text"
          ref="inputRef"
          v-model="searchMeg"
          @keyup.enter="doSearch"
        />
      </div> -->

      <div
        class="x-header__right flex align-center justify-between flex-sub"
        style="display: flex; justify-content: flex-end"
      >
        <!-- <div
          class="icon-left tab-item"
          :class="{
            'header-current':
              this.$route.path == '/shopcar' ||
              this.$route.path == '/sub' ||
              this.$route.path == '/shopintention',
          }"
          @click="navigatorTo('/shopcar')"
        >
          <i class="el-icon-shopping-cart-2"></i>

          <div v-show="cart" class="car-dot">{{ cart }}</div>
        </div>
        <p
          class="tab-item"
          :class="{
            'header-current':
              this.$route.path == '/order/list' ||
              this.$route.path == '/order/detail',
          }"
          @click="navigatorTo('/order/list')"
        >
          订单
        </p> -->
        <!-- <p
          class="tab-item"
          :class="{
            'header-current': isOffer(),
          }"
          v-on:click="navigatorTo('/project/list?channel=xshop')"
        >
          报价
        </p> -->

        <!-- <div class="tab-item">
          <el-popover popper-class="cu-el-popover" v-if="visable">
            <div class="child-tab">
              <div
                class="child-tab__item"
                :class="{ active: isActive('/customer/list', true) }"
                @click="navigatorTo('/xcrm/customer/list')"
              >
                客户管理
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/project/list', true) }"
                @click="navigatorTo('/xcrm/project/list')"
              >
                项目管理
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/audit/list', true) }"
                @click="navigatorTo('/xcrm/audit/list')"
              >
                审核中心
              </div>
              <div
                class="child-tab__item"
                :class="{ active: isActive('/task', true) }"
                @click="navigatorTo('/xcrm/task')"
              >
                任务列表
              </div>
            </div>
            <span slot="reference">全案转化</span>
          </el-popover>
          <span v-else @click="$login()">全案转化</span>
        </div> -->
        <!-- <div class="tab-item">
          <Notice></Notice>
        </div> -->
        <div class="clickOut tab-item" v-on:click="loginNow">
          <p class="clickOut">{{ headerName }}</p>
          <i class="el-icon-user-solid icon-spe clickOut"></i>
        </div>
      </div>
    </div>

    <!-- <el-dialog
      title="当前登录账号"
      :visible.sync="showLoginState"
      width="440px"
      center
    >
      <span>需要注意的是内容是默认不居中的</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";
// import Notice from "../notice";
import { navigatorTo, otherRoutes } from "../utils";
export default {
  name: "x-xshop-header",
  // components: { Notice },
  data() {
    return {
      logo: require("../image/logo.png"),
      hoverIndex: false,
      msg: "this is index",
      searchMeg: "",
      showLoginState: false,
      intention: "",
      order: "",
      userName: "",
      userCode: "",
      headerName: "账号登录",
      cart: "",
      propver: true,
      visable: false,
    };
  },
  mounted() {
    if (this.props) {
      this.searchMeg = this.props.searchMes;
    }
    // this.getOrderInfo();
    if (localStorage.getItem("users.access_token")) {
      let token = localStorage.getItem("users.access_token");
      let user = jwt_decode(token);
      this.headerName = user.UserName;
      localStorage.setItem("user", JSON.stringify(user));
      this.visable = true;
    } else {
      this.visable = false;
    }
    // console.log(this.$route);
  },
  props: {
    searchMes: {
      type: String,
    },
  },
  methods: {
    navigatorTo(path) {
      navigatorTo.call(this, path);
    },

    showPopper() {
      this.$login();
      return false;
    },

    isActive(e, isOther) {
      if (isOther) {
        const result = otherRoutes.filter((item) =>
          location.pathname.includes(item)
        );
        return result.length > 0 && e === this.$route.path;
      }
      return e === this.$route.path;
    },

    isOffer() {
      const route = this.$route;
      return (
        route.path.indexOf("project/list") > -1 &&
        route.query.channel === "xshop"
      );
    },

    doSearch() {
      // console.log(this.searchMeg);
      this.$refs.inputRef.blur();
      this.$router.push({
        path: "/product/search",
        query: { keywords: this.searchMeg },
      });
    },
    goOrderSelf() {
      this.$router.replace("/order/list");
    },
    goIntentionSelf() {
      this.$router.push("/intention/list");
    },
    logOut() {
      localStorage.clear();
      if (this.$route.path == "/") {
        this.$router.go(0);
      } else {
        this.$router.push("/");
      }
    },
    loginNow() {
      if (localStorage.getItem("users.access_token")) {
        this.$logout();
        // this.hoverIndex = !this.hoverIndex;
        // let token = localStorage.getItem("users.access_token");
        // // console.log(jwt_decode(token))
        // this.userName = jwt_decode(token).UserName;
        // this.userCode = jwt_decode(token).Mobile;
      } else {
        this.$login();
      }
    },
    onClickOutside() {
      this.hoverIndex = false;
    },
    showLogInfo() {
      // console.log("1233");
    },
  },
};
</script>

<style>
.cu-el-popover {
  padding: 0 !important;
}
</style>
<style lang="less" scoped>
div {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
}

.child-tab {
  width: 160px;

  .child-tab__item {
    font-size: 16px;
    padding: 8px 0;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: #f8e9e5;
      font-weight: 500;
    }

    &.active {
      background: #f8e9e5;
      font-weight: 500;
    }
  }
}

.x-header {
  background: #333333;
  width: 100%;
  height: 78px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  -webkit-font-smoothing: antialiased;

  .x-header__wrapper {
    height: 100%;
    width: 1440px;
    margin: 0 auto;
  }

  .x-header__left,
  .x-header__right {
    height: 100%;
    padding: 0 38px;
  }

  .tab-item {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
    &.logo {
      position: relative;
      top: -5px;
    }
  }
}

.input-search {
  display: inline-block;
  position: relative;
  input {
    width: 320px;
    height: 48px;
    border-radius: 24px;
    border: none;
    text-decoration: none;
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    border: none;
    border-style: none;
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    text-indent: 56px;
  }
  .icon-input {
    cursor: pointer;
    position: absolute;
    left: 20px;
    color: #999999;
    font-size: 20px;
    top: 14px;
  }
}
.login-content {
  padding: 30px 60px 40px;
}
.login-code {
  font-size: 20px;
  color: #333333;
}
.login-name {
  margin-top: 40px;
  font-size: 26px;
  color: #333333;
}
.login-order {
  margin-top: 38px;
  overflow: hidden;
  font-size: 16px;
  color: #333333;
  line-height: 48px;
  p {
    width: 146px;
    background: #ffffff;
    border: 1px solid #333333;
    border-radius: 3px;
  }
}
.log-out {
  background: #b92500;
  border-radius: 3px;
  width: 320px;
  height: 48px;
  line-height: 48px;
  font-size: 20px;
  color: #ffffff;
  margin-top: 50px;
  cursor: pointer;
}

.header-current {
  border-bottom: 2px solid #fff;
  font-weight: bold;
}
.icon-spe {
  background-color: #f5f5f5;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  font-size: 24px;
  padding: 6px;
  margin-left: 16px;
  box-sizing: border-box;
  color: #333;
}
.icon-left {
  display: inline;
  position: relative;
  // top: 1px;
  cursor: pointer;

  i {
    font-size: 24px;
  }

  .car-dot {
    position: absolute;
    background: #b92500;
    width: 15px;
    height: 15px;
    top: 25px;
    right: -8px;
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    color: #fff;
  }
}
</style>
